export function currentUserInfo(callback) {
    fetch("/S4S/api/Authentication/CurrentUserInfo", {
        "headers": {
            "content-type": "application/json",
        },
        "body": "",
        "method": "POST",
        "mode": "cors",
        "credentials": "include"
    })
    .then(function(data){ 
        return data.json();
    })
    .then(function(data){ 
        callback(data);
    })
}